import React, { useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";

// Partage partiel société construction
// Id simulateur 80

function Simulateur_80(props) {
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const [departement, setDepartement] = useState(0);
  const [valeur_biens, setBiens] = useState(0);
  const [nombre_part_partage, setPartage] = useState(0);
  const [nombre_parts_capital, setCapital] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);

  const handleChange = async (setter, value, key) => {
    if (setter === setDepartement) {
      setDepartement(parseInt(value));
    } else setter(value);
    setInRedux(setter, value, key);
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  function setInRedux(setter, value, key) {
    if (props.isParent) {
      let object = {
        simulateurid: props.simulateur.id,
        departementid: parseInt(departement),
        inputs: {
          valeur_biens: parseInt(valeur_biens),
          nombre_part_partage: parseInt(nombre_part_partage),
          nombre_parts_capital: parseInt(nombre_parts_capital),
          montant_deb_add: parseInt(montantDeboursAdditionnels),
          debours_additionnels: parseInt(deboursAdditionnels),
          convention_honoraires : parseInt(props.conventionHonoraires),
        },
        pdfInputs: {
          nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
          object_convention_honoraires : props.objectConventionHonoraires,
          montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
          nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
          adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
        },
      };
      //For values coming from components
      if (key) {
        if (key === "debours_additionnels") {
          if (value === 0) {
            setMontantDeboursAdditionnels(0)
            Object.assign(object["inputs"], { montant_deb_add: parseInt(0) });
          }
          Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
        }
        if (key === "montant_deb_add") {
          Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
        }
      }
      //For internal settings
      if (setter === setDepartement) {
        object.departementid = parseInt(value);
      }

      if (setter === setBiens) {
        Object.assign(object["inputs"], { valeur_biens: parseInt(value) });
      }

      if (setter === setPartage) {
        Object.assign(object["inputs"], { nombre_part_partage: parseInt(value) });
      }

      if (setter === setCapital) {
        Object.assign(object["inputs"], { nombre_parts_capital: parseInt(value) });
      }

      if (setter === props.setConventionHonoraires) {
        if(value === 0){
          props.setNombreConventionHonoraires(1);
          props.setObjectConventionHonoraires(null);
          props.setMontantConventionHonoraires(null);
          props.setNomSignataireConventionHonoraires(null);
          props.setAdresseSignataireConventionHonoraires(null);
          Object.assign(
            object["inputs"], { convention_honoraires : parseInt(value) },
            object["pdfInputs"], {
              nombre_convention_honoraires : null,
              object_convention_honoraires : null,
              montant_convention_honoraires : null,
              nom_signataire_convention_honoraires : null,
              adresse_signataire_convention_honoraires : null
            },
          );
        } else {
          Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
        }
      }

      if (setter === props.setNombreConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) });
      }

      if (setter === props.setObjectConventionHonoraires) {
        Object.assign(object["pdfInputs"], { object_convention_honoraires : value });
      }

      if (setter === props.setMontantConventionHonoraires) {
        Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)});
      }

      if (setter === props.setNomSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
      }

      if (setter === props.setAdresseSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
      }

      dispatch(setSimulateurObject(object));
    } else {
      // process child simu
    }
  }

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        <p style={styles.cardSubTitle}>
          Acte tarifé au titre du Tableau 5, n° 100 (Art A444-120). Le montant des émoluments supportés par chaque
          copartageant sortant de la société ne pourra être supérieur au montant de ceux dont il aurait été redevable si
          le partage avait été total.
        </p>

        {props?.isParent === true && props.departements !== "" ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Département :</div>

            <SelectDepartement
              items={props.departements}
              nameField={"name"}
              defaultValue={currUserDep}
              optionValue={"id"}
              handleChange={handleChange}
              setter={setDepartement}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Quelle est la valeur totale des biens immobiliers objet du partage partiel de société construction ?
          </div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer la valeur"}
            setter={setBiens}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Combien de parts sociales font l’objet du partage partiel ?</div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le nombre"}
            setter={setPartage}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Quel est le nombre total de parts sociales composant le capital social initial de la société de construction
            ?
          </div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le nombre"}
            setter={setCapital}
          />
        </div>

        <DeboursQuestion
            handleChange={handleChange}
            deboursAdditionnels={deboursAdditionnels}
            setDeboursAdditionnels={setDeboursAdditionnels}
            setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
        />

        <ConventionHonoraires
          handleChange={handleChange}
          conventionHonoraires={props.conventionHonoraires}
          setConventionHonoraires={props.setConventionHonoraires}
          nombreConventionHonoraires={props.nombreConventionHonoraires}
          setNombreConventionHonoraires={props.setNombreConventionHonoraires}
          objectConventionHonoraires={props.objectConventionHonoraires}
          setObjectConventionHonoraires={props.setObjectConventionHonoraires}
          montantConventionHonoraires={props.montantConventionHonoraires}
          setMontantConventionHonoraires={props.setMontantConventionHonoraires}
          nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
          setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
          adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
          setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
      </div>
    </div>
  );
}

export default Simulateur_80;
